import React, { useState } from 'react';
import {  Table, Modal, Button, Input, Typography, Space, message, Spin, Select } from 'antd';
import AssessmentPage from './AssessmentPage';
import { useAppContext } from './AppContext';
import EmployeeTree from './EmployeeHierarchy';
import { useEffect } from 'react';
import { directReportsURL, employeesURL } from '../Config';


const { Text } = Typography;
const { Search } = Input;
const { Option } = Select;

const ListOfEmployee = () => {
  const [sortedInfo, setSortedInfo] = useState({});
  const { filteredTableData, setFilteredTableData } = useAppContext();
  const { reportType, setReportType } = useAppContext();
  const { tableData, setTableData } = useAppContext();
  const { AdvanceFilter, upName,isAdmin,idToken } = useAppContext();
  const [filteredInfo, setFilteredInfo] = useState({});
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [shouldClearFilters, setShouldClearFilters] = useState(true); // New flag to control filter clearing
  const [rankingChanges, setRankingChanges] = useState({});
  const [saveTimeout, setSaveTimeout] = useState(null);
  const [pendingSave, setPendingSave] = useState(false);
  const [savingRankings, setSavingRankings] = useState(false);
  const [pagination, setPagination] = useState({ pageSize: 20, current: 1 });
  const [empSearchValue, setEmpSearchValue] = useState('');
  const [managerSearchValue, setManagerSearchValue] = useState('');
  const [jobLevelSearchValue, setJobLevelSearchValue] = useState('');
  const [locationSearchValue, setLocationSearchValue] = useState('');
  const [nineBoxSearchValue, setNineBoxSearchValue] = useState('');

  const nineboxMappingOrder = {
    "Poor Fit": 1,
    "Needs Performance Management": 2,
    "Needs Improvement": 3,
    "Suitably Placed": 4,
    "Solid Performer": 5,
    "Valued Professional": 6,
    "Expandable": 7,
    "Promotable": 8,
    "Top Talent": 9
  };

  message.config({
    className: 'ant-message-custom-content',
    duration: 3, // Adjust the duration as needed
  })

  //*****************Column search*********************/

  const handleRefresh = () => {
    //console.log('Refresh Flag before toggle:', refreshFlag);
    setRefreshFlag(prevFlag => !prevFlag);
    setShouldClearFilters(true); // Mark that filters should be cleared
    
    // Clear all search values
    setEmpSearchValue('');
    setManagerSearchValue('');
    setJobLevelSearchValue('');
    setLocationSearchValue('');
    setNineBoxSearchValue('');
    
    // Clear advance filters
    AdvanceFilter('userName', '');
    AdvanceFilter('managerName', '');
    AdvanceFilter('jobLevel', '');
    AdvanceFilter('location', '');
    AdvanceFilter('nineboxmapping', '');
    
    //console.log('Refresh Flag after toggle:', !refreshFlag);
  };

  // New function to refresh data without clearing filters
  const handleRefreshWithoutClearingFilters = () => {
    //console.log('Refreshing data without clearing filters');
    setShouldClearFilters(false); // Mark that filters should NOT be cleared
    setRefreshFlag(prevFlag => !prevFlag);
  };

  useEffect(() => {

    // Only clear search values if specifically requested (initial load or explicit refresh)
    if (shouldClearFilters) {
      setEmpSearchValue('');
      setManagerSearchValue('');
      setJobLevelSearchValue('');
      setLocationSearchValue('');
      setNineBoxSearchValue('');

      AdvanceFilter('userName', '');
      AdvanceFilter('managerName', '');
      AdvanceFilter('jobLevel', '');
      AdvanceFilter('location', '');
      AdvanceFilter('nineboxmapping', '');
    }

    const fetchData = async () => {
      setLoading(true);
      //console.log('Fetching data for:', upName);
      setTableData([]);
      
      try {
        const requestData = {
          userId: upName
        };

        //console.log(directReportsURL);
        //console.log(requestData);
        //console.log(idToken);

        const response = await fetch(directReportsURL+ `/${upName}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });
                
        
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const data = await response.json();
        console.log('Data fetched successfully:', data);
        
        // Debug: Log the first item to see available fields
        if (data && data.length > 0) {
          console.log('Available fields in API response:', Object.keys(data[0]));
          console.log('Sample data item:', data[0]);
        }
        
        // Process data to ensure proper keys and 9Box mapping
        const processedData = data.map((item, index) => ({
          ...item,
          key: item.key || item.userEmail || item.userPrincipalName || `emp_${index}`,
          // Ensure 9Box mapping field exists and is properly formatted
          nineboxmapping: item.nineboxmapping || item.nineBoxMapping || item.nineboxMapping || '',
          // Ensure other critical fields exist
          userName: item.userName || item.userDisplayName || '',
          managerName: item.managerName || item.managerDisplayName || '',
          jobLevel: item.jobLevel || '',
          location: item.location || item.workLocation || '',
          performancerating: item.performancerating || item.performanceRating || item.performance_rating || item.performanceRatingValue || '',
          potentialrating: item.potentialrating || item.potentialRating || item.potential_rating || item.potentialRatingValue || ''
        }));
        
        setTableData(processedData);
        setReportType('All Employees');
        
      } catch (error) {
        //console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [upName, refreshFlag]);
  



  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    setFilteredInfo(filters);
    setPagination({
      ...pagination,
      pageSize: pagination.pageSize, // Update pageSize dynamically
    });
  };

  const handleRankChange = (key, newRank, rankType) => {
    //console.log('Key:', key);
    //console.log('New Rank:', newRank);
    //console.log('Rank Type:', rankType);

    // Only proceed if the new rank is a valid integer or empty
    if (newRank === '' || (!isNaN(newRank) && Number.isInteger(Number(newRank)) && Number(newRank) >= 0)) {
      const updateData = (item) => {
        if (item.key === key) {
          if (rankType === 'ELT') {
            return { ...item, eltRanking: newRank === '' ? '' : Number(newRank) };
          } else {
            return { ...item, overallRanking: newRank === '' ? '' : Number(newRank) };
          }
        }
        return item;
      };

      setFilteredTableData(prevData => {
        const newData = prevData.map(updateData);
        //console.log('Updated Data:', newData);
        return newData;
      });

      if (saveTimeout) {
        clearTimeout(saveTimeout);
      }

      setPendingSave(true);
    }
  };

  useEffect(() => {
    if (pendingSave) {
      //console.log('handleRankChange filteredTableData:', filteredTableData);

      setSavingRankings(true);
      
      // Delay the save operation to debounce rapid changes
      const timeout = setTimeout(() => {
        setPendingSave(false);
        handleSave();
      }, 10000);
  
      setSaveTimeout(timeout);
  
      // Cleanup the timeout if the component unmounts or if handleSave is called again before the timeout completes
      return () => clearTimeout(timeout);
    }
  }, [filteredTableData, pendingSave]);

  const columns = [

    {
      title: <strong>Emp Name</strong>,
      dataIndex: 'userName',
      key: 'userName',
      fixed: 'left',
      width: 250,
      onCell: (record) => ({
        onClick: () => showModal(record),
      }),
      sorter: (a, b) => (a.userName || '').localeCompare(b.userName || ''),

      render: (text) => (
        <span style={{ fontWeight: 'bold', color: '#3498DB', cursor: 'pointer' }}  >
          {text}
        </span>
      )
    },
    {
      title: <strong>Hire Date</strong>,
      dataIndex: 'hireDate',
      key: 'hireDate',
      width: 150,
      sorter: (a, b) => (a.hireDate || '').localeCompare(b.hireDate || ''),
      render: (text) => {
        // Parse the date string
        const date = new Date(text);
        // Options for formatting the date
        const options = { day: '2-digit', month: 'short', year: '2-digit' };
        // Format the date using options
        const formattedDate = date.toLocaleDateString('en-US', options);
        // Return the formatted date
        return formattedDate;
      },
    },
    {
      title: <strong>Tenure</strong>,
      dataIndex: 'tenure',
      key: 'tenure',
      sorter: (a, b) => (a.tenure || 0) - (b.tenure || 0),
      render: (text) => {
        return text + ' years';
      }
    },
    {
      title: <strong>Job Title</strong>,
      dataIndex: 'jobTitle',
      key: 'jobTitle',
      width: 250,
      sorter: (a, b) => (a.jobTitle || '').localeCompare(b.jobTitle || ''),
    },
    {
      title: <strong>Job Level</strong>,
      dataIndex: 'jobLevel',
      key: 'jobLevel',
      sorter: (a, b) => (a.jobLevel || '').localeCompare(b.jobLevel || ''),
    },
    {
      title: <strong>Location</strong>,
      dataIndex: 'location',
      key: 'location',
      width: 200,
      sorter: (a, b) => (a.location || '').localeCompare(b.location || ''),
    },
    {
      title: <strong>Manager Name</strong>,
      dataIndex: 'managerName',
      key: 'managerName',
      width: 250,
      sorter: (a, b) => (a.managerName || '').localeCompare(b.managerName || ''),

    },
    {
      title: <strong>Performance Rating</strong>,
      dataIndex: 'performancerating',
      key: 'performancerating',
      width: 250,
      sorter: (a, b) => (a.performancerating || '').localeCompare(b.performancerating || ''),
    },
    {
      title: <strong>Potential Rating</strong>,
      dataIndex: 'potentialrating',
      key: 'potentialrating',
      width: 250,
      sorter: (a, b) => (a.potentialrating || '').localeCompare(b.potentialrating || ''),
    },
    /* {
      title: <strong>Pontential Rating Score</strong>,
      dataIndex: 'potentialRatingScore',
      key: 'potentialRatingScore',
      sorter: (a, b) => a.potentialRatingScore - b.potentialRatingScore
    }, */
    {
      title: <strong>9 Box Mapping</strong>,
      dataIndex: 'nineboxmapping',
      key: 'nineboxmapping',
      width: 250,
      sorter: (a, b) => {
        // Use the mapping to sort by numerical value
        const aValue = nineboxMappingOrder[a.nineboxmapping] || 0;
        const bValue = nineboxMappingOrder[b.nineboxmapping] || 0;
        return aValue - bValue;
      },
      render: (text, record) => {
        // Handle empty or undefined 9Box mapping
        if (!text || text.trim() === '') {
          return <span style={{ color: '#999', fontStyle: 'italic' }}>Not Assigned</span>;
        }

        let color;
        let backgroundColor;
        
        // Normalize the text for comparison (trim and handle case)
        const normalizedText = text.trim();
        
        if (normalizedText === 'Poor Fit' || normalizedText === 'Needs Performance Management' || normalizedText === 'Needs Improvement') {
          color = '#C51E1E';
          backgroundColor = '#F9ECEC';
        } else if (normalizedText === 'Promotable' || normalizedText === 'Expandable' || normalizedText === 'Top Talent') {
          color = '#008000';
          backgroundColor = '#DCF3D9';
        } else if (normalizedText === 'Suitably Placed' || normalizedText === 'Solid Performer' || normalizedText === 'Valued Professional') {
          color = '#D68910';
          backgroundColor = '#FCF3CF';
        } else {
          color = '#333';
          backgroundColor = '#f5f5f5';
        }

        return (
          <span 
            style={{ 
              backgroundColor, 
              color, 
              fontWeight: 'bold', 
              padding: '8px 12px', 
              borderRadius: '8px', 
              fontSize: '14px',
              display: 'inline-block',
              minWidth: '120px',
              textAlign: 'center',
              border: `1px solid ${color}20`
            }}
          >
            {normalizedText}
          </span>
        );
      }
    },
    {
      title: <strong>ELT Ranking</strong>,
      dataIndex: 'eltRanking',
      key: 'eltRanking',
      fixed: 'right',
      width: 100,
      render: (text, record) => {

        return (
          <Input 
            defaultValue={text ? text.toString() : ''} 
            onChange={(e) => {
              const value = e.target.value;
              // Allow empty string or positive integers only
              if (value === '' || /^[0-9]+$/.test(value)) {
                handleRankChange(record.key, value, 'ELT');
              }
            }}
            onKeyPress={(e) => {
              // Prevent non-numeric characters
              if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                e.preventDefault();
              }
            }}
            placeholder="Enter number"
          />
        )
      },
      sorter: (a, b) => {
        // Handle empty values separately
        if (!a.eltRanking && !b.eltRanking) {
          return 0; // If both values are empty, consider them equal
        } else if (!a.eltRanking) {
          return 1; // Empty value should go at the end
        } else if (!b.eltRanking) {
          return -1; // Empty value should go at the end
        } else {
          return a.eltRanking - b.eltRanking; // Normal sorting for non-empty values
        }
      },
      defaultSortOrder: 'ascend'
    },
    {
      title: <strong>Overall Ranking</strong>,
      dataIndex: 'overallRanking',
      key: 'overallRanking',
      fixed: 'right',
      width: 100,
      render: (text, record) => {

        return (
          <Input 
            defaultValue={text ? text.toString() : ''} 
            onChange={(e) => {
              const value = e.target.value;
              // Allow empty string or positive integers only
              if (value === '' || /^[0-9]+$/.test(value)) {
                handleRankChange(record.key, value, 'OVERALL');
              }
            }}
            onKeyPress={(e) => {
              // Prevent non-numeric characters
              if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') {
                e.preventDefault();
              }
            }}
            placeholder="Enter number"
          />
        )
      },
      sorter: (a, b) => {
        // Handle empty values separately
        if (!a.overallRanking && !b.overallRanking) {
          return 0; // If both values are empty, consider them equal
        } else if (!a.overallRanking) {
          return 1; // Empty value should go at the end
        } else if (!b.overallRanking) {
          return -1; // Empty value should go at the end
        } else {
          return a.overallRanking - b.overallRanking; // Normal sorting for non-empty values
        }
      },
    }
  ];

  if(isAdmin){
    columns.splice(8,0,{
      title: <strong>Pontential Rating Score</strong>,
      dataIndex: 'potentialRatingScore',
      key: 'potentialRatingScore',
      sorter: (a, b) => (a.potentialRatingScore || 0) - (b.potentialRatingScore || 0)
    })}

  const tableStyle = {
    border: '1px solid #d9d9d9', // Set the border style
  };


  const [modalVisible, setModalVisible] = useState(false);



  const showModal = (record) => {
    setSelectedData(record);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const calculateModalWidth = () => {
    // Calculate 75% of the parent window width
    const parentWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    return Math.round((parentWidth * 0.90) / 100) * 100; // Round to the nearest 100 pixels
  };

  const [filters, setFilters] = useState({ managerName: '' });

  const handleFilterChange = (filterType, value) => {
    setFilters({ ...filters, [filterType]: value });
    AdvanceFilter(filterType, value);
  };

  // Function to apply all filters
  const applyFilters = () => {
    let filteredResults = [...tableData]; // Create a copy to avoid mutation
    
    // First apply report type filter
    if (reportType === 'Direct Reports') {
      filteredResults = filteredResults.filter(item => 
        item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
      );
    } else if (reportType === 'Indirect Reports') {
      filteredResults = filteredResults.filter(item => 
        item.managerEmail && item.managerEmail.toString().toLowerCase() !== upName.toString().toLowerCase()
      );
    }
    
    // Apply search filters with null/undefined checks
    if (empSearchValue && empSearchValue.trim()) {
      filteredResults = filteredResults.filter(item => 
        item.userName && item.userName.toLowerCase().includes(empSearchValue.toLowerCase())
      );
    }
    
    if (managerSearchValue && managerSearchValue.trim()) {
      filteredResults = filteredResults.filter(item => 
        item.managerName && item.managerName.toLowerCase().includes(managerSearchValue.toLowerCase())
      );
    }
    
    if (jobLevelSearchValue && jobLevelSearchValue.trim()) {
      filteredResults = filteredResults.filter(item => 
        item.jobLevel && item.jobLevel.toLowerCase().includes(jobLevelSearchValue.toLowerCase())
      );
    }
    
    if (locationSearchValue && locationSearchValue.trim()) {
      filteredResults = filteredResults.filter(item => 
        item.location && item.location.toLowerCase().includes(locationSearchValue.toLowerCase())
      );
    }
    
    if (nineBoxSearchValue && nineBoxSearchValue.trim()) {
      filteredResults = filteredResults.filter(item => 
        item.nineboxmapping && item.nineboxmapping.toLowerCase().includes(nineBoxSearchValue.toLowerCase())
      );
    }
    
    // Ensure each item has a unique key for proper React rendering
    const resultsWithKeys = filteredResults.map((item, index) => ({
      ...item,
      key: item.key || item.userEmail || item.userPrincipalName || index
    }));
    
    setFilteredTableData(resultsWithKeys);
  };

  // Effect to apply filters whenever search values change
  useEffect(() => {
    applyFilters();
  }, [empSearchValue, managerSearchValue, jobLevelSearchValue, locationSearchValue, nineBoxSearchValue, reportType, tableData]);

  const handleReportChange = (value) => {
    setReportType(value);
    // The filtering will be handled by the useEffect above
  };



  const handleSave = () => {

    //console.log('Filtered Table Data:', filteredTableData);
    setSavingRankings(true);

    const changedData = filteredTableData.map(row => {
      // Convert eltRanking to string before sending
      const eltRankingAsString = String(row.eltRanking);
      const overallRankingAsString = String(row.overallRanking);
      // Map to include only eltRanking and overallRanking fields
      return {
        userEmail: row.userEmail,
        userPrincipalName: row.userPrincipalName,
        eltRanking: eltRankingAsString,
        overallRanking: overallRankingAsString
      };
    });

    //console.log('Changed data:', changedData);

    fetch(employeesURL + '/list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(changedData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to save data');
        }

        return response.json();

      })
      .then(data => {

        //console.log('Data saved successfully:', data);
        setSavingRankings(false);
        handleRefreshWithoutClearingFilters(); // Use filter-preserving refresh
      })
      .catch(error => {
        //console.error('Error saving data:', error);
        setSavingRankings(false);
        handleRefreshWithoutClearingFilters(); // Use filter-preserving refresh
      });

    message.success("Saved");

   
  };


  return (

    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 10px', marginBottom: '10px' }}>
        <Space >
          <Select defaultValue="All Employees" style={{ width: 150 }} onChange={handleReportChange}>
            <Option value="Direct Reports">Direct Reports</Option>
            <Option value="Indirect Reports">Indirect Reports</Option>
            <Option value="All Employees">All Employees</Option>
          </Select>
          <Search
            placeholder="Employee"
            value={empSearchValue}
            onChange={e => setEmpSearchValue(e.target.value)}
            onSearch={value => setEmpSearchValue(value)} />
          <Search
            placeholder="Manager"
            value={managerSearchValue}
            onChange={e => setManagerSearchValue(e.target.value)}
            onSearch={value => setManagerSearchValue(value)} />          
          <Search
            placeholder="Job Level"
            value={jobLevelSearchValue}
            onChange={e => setJobLevelSearchValue(e.target.value)}
            onSearch={value => setJobLevelSearchValue(value)} />          
          <Search
            placeholder="Location"
            value={locationSearchValue}
            onChange={e => setLocationSearchValue(e.target.value)}
            onSearch={value => setLocationSearchValue(value)} />
          <Search
            placeholder="9 Box Category"
            value={nineBoxSearchValue}
            onChange={e => setNineBoxSearchValue(e.target.value)}
            onSearch={value => setNineBoxSearchValue(value)} />

          <Button style={{marginRight:10, marginLeft:20}} onClick={handleRefresh} type="primary">Refresh</Button>        
        </Space>
        <Button 
          onClick={handleSave} 
          type="primary" 
          loading={savingRankings}
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
        >
          {savingRankings ? 'Saving...' : 'Save'}
        </Button>
        
      </div>
      <div style={{ margin: 10 }}>
        <Spin size="large" spinning={loading}>
          <Table
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              pageSizeOptions: ['5', '10', '15','20','50','100'],
              showSizeChanger: true,
            }}
            columns={columns}
            scroll={{ x: true }}
            dataSource={filteredTableData}
            style={tableStyle}
            filteredInfo={filteredInfo}
            onChange={handleChange}
          />
        </Spin>
      </div>
      <Modal
        style={{ top: 5 }}
        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={calculateModalWidth()}
      >

        <div>
          <EmployeeTree clickable={false} />
          <br />
          <AssessmentPage data={selectedData} handleRefresh={handleRefreshWithoutClearingFilters} onSaveComplete={handleModalClose} />
        </div>

      </Modal>
    </div>

  );
};

export default ListOfEmployee;